import _implicitStylesheets from "./badge.css";
import _implicitScopedStylesheets from "./badge.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, d: api_dynamic_text, t: api_text, h: api_element} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.classes),
    key: 0
  }, [$cmp.hasIcon ? api_custom_element("ax-icon", _axIcon, {
    props: {
      "size": "xsmall",
      "icon": $cmp.icon,
      "iconDescription": $cmp.iconDescription
    },
    key: 1
  }) : null, api_text(api_dynamic_text($cmp.text))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-tcmtdf9qei";
tmpl.legacyStylesheetToken = "undefined-_badge";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
